'use client';

import { Field } from '.';
import { ComponentPropsWithoutRef, ComponentPropsWithRef } from 'react';
import { cn } from '@/shared/lib/cn';
import './field.scss';

type Props = ComponentPropsWithoutRef<typeof Field> & ComponentPropsWithRef<'textarea'>;
export const TextareaField = ({
    id,
    name,
    placeholder = ' ',
    label,
    state,
    disabled,
    right,
    className,
    labelProps,
    legendProps,
    fieldsetProps,
    ...props
}: Props) => {
    const fieldId = label && !id ? name : id;

    return (
        <Field
            id={fieldId}
            disabled={disabled}
            label={label}
            right={right}
            state={state}
            labelProps={labelProps}
            legendProps={legendProps}
            fieldsetProps={fieldsetProps}
        >
            <textarea
                id={label ? fieldId : undefined}
                placeholder={placeholder}
                className={cn('field__input', 'field__input--textarea', className)}
                aria-invalid={state === 'error'}
                disabled={disabled}
                {...props}
            />
        </Field>
    );
};
